import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import screenfull from 'screenfull';
import Scrollbar from 'components/Scrollbar';
import { BackgroundStyled, MenuRootStyled } from './styled/MenuStyled';
import { getIsDesktopEpgPresent } from '../../utils/isDesktopEpgPresent';

export const withMenu = (Child) =>
  class extends PureComponent {
    static propTypes = {
      onClose: PropTypes.func.isRequired,
    };

    constructor(props) {
      super(props);
      this.state = {
        isVisible: false,
      };
      this.containerRef = React.createRef();
      this.menuContainer =
        screenfull.enabled && screenfull.isFullscreen
          ? screenfull.element
          : this.getCMSSectionContainer() || document.querySelector('body');
      this.overflowElement = this.getOverflowCMSElement();
      this.initalOverflowValue = this.overflowElement
        ? this.overflowElement.style.overflow
        : 'auto';
      // mobile skin could be with the desktop epg
      this.isDesktopEpgPresent = getIsDesktopEpgPresent();
      this.setHeight();
    }

    componentDidMount() {
      // for appearing animation
      setTimeout(() => {
        this.setState({
          isVisible: true,
        });
      }, 10);

      if (!this.props.isTV && this.overflowElement)
        this.overflowElement.style.overflow = 'hidden';
      window.addEventListener('resize', this.setHeight);
    }

    componentWillUnmount() {
      if (!this.props.isTV && this.overflowElement)
        this.overflowElement.style.overflow = this.initalOverflowValue;
      window.removeEventListener('resize', this.setHeight);
    }

    setHeight = () => {
      const menuHeight = document.documentElement.clientHeight;
      document.documentElement.style.setProperty(
        '--menuHeight',
        `${menuHeight - 100}px`
      );
    };

    onTransitionEnd = (event) => {
      // property name could be background-color or background
      if (event.propertyName.includes('background') && !this.state.isVisible) {
        this.props.onClose();
      }
    };

    onBackgroundClick = (event) => {
      if (event.target === event.currentTarget) {
        this.setState({ isVisible: false });
      }
    };

    onNeedToCloseByChildren = () => {
      this.setState({ isVisible: false });
    };

    getCMSSectionContainer = () =>
      document.querySelector('.player-place section');
    getOverflowCMSElement = () => document.querySelector('body #widget_1');

    render() {
      const { ...childProps } = this.props;
      const { isVisible } = this.state;
      return ReactDOM.createPortal(
        <BackgroundStyled
          isVisible={isVisible}
          isTV={this.props.isTV}
          isDesktopEpgPresent={this.isDesktopEpgPresent}
          onTransitionEnd={this.onTransitionEnd}
          onClick={this.onBackgroundClick}
        >
          <MenuRootStyled isVisible={isVisible}>
            <Scrollbar maxHeight={`var(--menuHeight)`} isTV={this.props.isTV}>
              <Child
                {...childProps}
                onNeedToClose={this.onNeedToCloseByChildren}
              />
            </Scrollbar>
          </MenuRootStyled>
        </BackgroundStyled>,
        this.menuContainer
      );
    }
  };
